import i18next from 'i18next';
import { useQuery, UseQueryOptions } from 'react-query';
import { fetchWrapper, formatLocalStorageKey } from '../utils';
import { NAVIGATION_ENDPOINTS } from '../constants/urls';
import { CustomObjectDefinitionsResponse } from '../types';
import useLocalStorage from '@rehooks/local-storage';

export const CUSTOM_OBJECT_LIST_QUERY_KEY = ['customObjectsMenu'];
export const PLATFORM_MENU_GROUP_ID = 'Zuora/Workflow';
export const OBJECT_MANAGER_ITEM_ID = `${PLATFORM_MENU_GROUP_ID}/ObjectManager`;
export const CUSTOM_OBJECTS_MENU_ID = 'Zuora/CustomObjectList';

export const useCustomObjectDefinition = (
  configs?: UseQueryOptions<CustomObjectDefinitionsResponse>,
) => {
  const [cachedNavData, setCachedNavData] =
    useLocalStorage<CustomObjectDefinitionsResponse>(
      formatLocalStorageKey('CustomObjectNavMenu'),
    );
  return useQuery({
    queryKey: CUSTOM_OBJECT_LIST_QUERY_KEY,
    queryFn: async () =>
      await fetchWrapper<CustomObjectDefinitionsResponse>(
        NAVIGATION_ENDPOINTS.CUSTOM_OBJECTS,
      ),
    initialData: () => {
      if (cachedNavData) {
        return cachedNavData;
      }
    },
    onSuccess: (data) => {
      setCachedNavData(data);
    },
    refetchInterval: 6 * 60 * 1000,
    refetchOnMount: true,
    staleTime: 0,
    ...configs,
  });
};

export const customObjectNavParentItem = {
  id: CUSTOM_OBJECTS_MENU_ID,
  label: 'Custom Objects',
  parentId: null,
  parentLabel: null,
};

export const useCustomObjectMapping = (
  configs?: UseQueryOptions<CustomObjectDefinitionsResponse>,
) => {
  const response = useCustomObjectDefinition(configs);
  const customObjectDefinitions = response?.data?.definitions || {};
  const customObjectNavItems = Object.entries(customObjectDefinitions).map(
    ([objectName, definition]) => {
      const id = `${customObjectNavParentItem.id}/${objectName}`;
      const { label } = definition.schema;
      const url = `https://${
        window.location.host
      }/platform/apps/default/${definition.type.toLowerCase()}`;

      return {
        id,
        label,
        url,
        parentId: customObjectNavParentItem.id,
        parentLabel: i18next.t('GlobalNav.Sections.CustomObjects'),
      };
    },
  );

  return {
    ...response,
    data: customObjectNavItems ?? [],
  };
};
